import React from "react";
import { useNavigate } from "react-router-dom";

const Process = () => {
  const navigate = useNavigate();
  return (
    <div className=" p-8 mt-4">
      <section className="  container mx-auto flex items-center flex-col  p-6 max-w-5xl rounded-lg my-2 border border-2 relative border-bgBlue ">
        <h2 className="font-semibold text-lg">
          آشنایی با فرایند کار کلینیک لانجویتی
        </h2>
        <img
          src="/assets/images/untitled-3.jpg"
          alt="process"
          className="max-sm:hidden"
        />
        <img
          src="/assets/images/untitled-1.jpg"
          alt="process"
          className="hidden max-sm:block my-2"
        />
        <button
          className=" absolute  hover:text-white container-with-button 
        hover:bg-bgBlue text-md   text-bgBlue px-4  py-2 w-fit rounded-lg flex items-center gap-2 cursor-pointer group max-md:mt-8 max-md:mx-auto font-bold  transition-all duration-200 bottom-0 translate-y-5 border-bgBlue border-2 bg-white z-20"
          onClick={() => navigate("/form")}
        >
          <span className=" mx-auto">تکمیل فرم ارزیابی</span>
        </button>
      </section>
    </div>
  );
};

export default Process;
